//grower-members.ts

import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";
import { GrowerMember } from "../../models/grower-member";

export const growerMembersApi = {
  get: (): Promise<GrowerMember[]> =>
    apiProvider
      .getAll("grower-members")
      .then((d: JsonDocument<GrowerMember[]>) => d.data),

  create: (email: string): Promise<GrowerMember> =>
    apiProvider
      .post("grower-members", {
        data: {
          email,
        },
      })
      .then((d: JsonDocument<GrowerMember>) => d.data),

  archive: (id: number): Promise<void> =>
    apiProvider.patch("grower-members", id, {}),
};
